/**
 * Renders the section-specific sub-nav when the user is inside a build (persuasion-lab/:runId).
 * Foundations has its own layout at foundations/:runId and does not use this router.
 */

import { FC } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { ArgumentBuilderSubNav } from './ArgumentBuilderSubNav'
import { ResearchAmplifierSubNav } from './ResearchAmplifierSubNav'
import { StoryHubSubNav } from './StoryHubSubNav'

export const SectionSubNavRouter: FC = () => {
    const { runId } = useParams<{ runId: string }>()
    const location = useLocation()
    const path = location.pathname

    if (!runId) return null
    if (path.includes('/argument-builder')) return <ArgumentBuilderSubNav />
    if (path.includes('/research')) return <ResearchAmplifierSubNav />
    if (path.includes('/stories')) return <StoryHubSubNav />
    if (path.includes('/creative-context')) return <StoryHubSubNav />
    return null
}
